<template>
	<span>{{ timeagoString }}</span>
</template>

<script>
import * as timeago from "timeago.js";

var locale = function (number, index, totalSec) {
	// number: the time ago / time in number;
	// index: the index of array below;
	// totalSec: total seconds between date to be formatted and today's date;
	return [
		["gerade eben", "vor einer Weile"],
		["vor %s Sekunden", "in %s Sekunden"],
		["vor 1 Minute", "in 1 Minute"],
		["vor %s Minuten", "in %s Minuten"],
		["vor 1 Stunde", "in 1 Stunde"],
		["vor %s Stunden", "in %s Stunden"],
		["vor 1 Tag", "in 1 Tag"],
		["vor %s Tagen", "in %s Tagen"],
		["vor 1 Woche", "in 1 Woche"],
		["vor %s Wochen", "in %s Wochen"],
		["vor 1 Monat", "in 1 Monat"],
		["vor %s Monaten", "in %s Monaten"],
		["vor 1 Jahr", "in 1 Jahr"],
		["vor %s Jahren", "in %s Jahren"],
	][index];
};
timeago.register("de", locale);

export default {
	props: {
		date: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			dateObj: new Date(Date.parse(this.date)),
			timeagoString: "",
			timeagoLocale: this.locale,
		};
	},
	mounted() {
		let currentDate = new Date(),
			that = this;
		if (
			currentDate - 30 * (24 * 60 * 60 * 1000) >= that.dateObj &&
			that.dateObj != null
		) {
			// date is more than 1 month ago, just show the actual date
			that.timeagoString =
				that.dateObj.getDate() +
				"." +
				(that.dateObj.getMonth() + 1) +
				"." +
				that.dateObj.getFullYear();
		} else {
			that.timeagoString = timeago.format(that.dateObj, that.timeagoLocale);
			setInterval(function () {
				that.timeagoString = timeago.format(that.dateObj, that.timeagoLocale);
			}, 10 * 1000);
		}
	},
};
</script>
